var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from '../../../pages/modules/base-entity';
import { autoinject, BindingEngine, transient } from 'aurelia-framework';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { EntityTypes } from '../../../../models/basics/basics.models';
import { RouterConstants } from '../../../../configuration/router.constants';
import { StepEnum, WinningAmountTypeEnum } from '../../../../models/modules/lotteryplatofrm.models';
import { SweepstakeClientService } from '../../../../services/modules/sweepstake-client-service';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import * as Enumerable from 'linq';
import { Guid } from '../../../../utilities/guid';
import { SweepstakeBasicMeta } from './steps/sweepstake-basic-meta';
import { SweepstakeTicketPrices } from './steps/sweepstake-ticket-prices';
import { SweepstakePrizeTiers } from './steps/sweepstake-prize-tiers';
import { SweepstakeTicketDiscounts } from './steps/sweepstake-ticket-discounts';
import { SweepstakeChangeLog } from './steps/sweepstake-changelog';
import { SweepstakeTicketLines } from './steps/sweepstake-ticket-lines';
import { SweepstakeTickets } from './steps/sweepstake-tickets';
import { BrandClientService } from '../../../../services/modules/brand-client.service';
import { UserClaimsService } from '../../../../services/authentication/user-claims.service';
import { BaseClaims } from '../../../../constants/authentication/base-claims';
import { DialogServiceConstants } from '../../../../constants/basics/dialog.constants';
import { SweepstakeDraw } from './steps/sweepstake-draws';
import { CreateSweepstakeDraw } from './dialogs/create-sweepstake-draw';
import { SweepstakeBrandSettings } from './steps/sweepstake-brand-settings';
var Sweepstake = /** @class */ (function (_super) {
    __extends(Sweepstake, _super);
    function Sweepstake(validationControllerFactory, dialogClientService, tokenClient, router, i18N, bindingEngine, notificationService, eventAggregator, sweepstakeClientService, sweepstakeBasicMeta, sweepstakePrizeTiers, userClaimsService, sweepstakeTicketPrices, sweepstakeTicketDiscounts, sweepstakeChangeLog, createSweepstakeDraw, brandClientService, sweepstakeTicketLines, sweepstakeTickets, sweepstakeDraw, sweepstakeBrandSettings) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.tokenClient = tokenClient;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.sweepstakeClientService = sweepstakeClientService;
        _this.sweepstakeBasicMeta = sweepstakeBasicMeta;
        _this.sweepstakePrizeTiers = sweepstakePrizeTiers;
        _this.userClaimsService = userClaimsService;
        _this.sweepstakeTicketPrices = sweepstakeTicketPrices;
        _this.sweepstakeTicketDiscounts = sweepstakeTicketDiscounts;
        _this.sweepstakeChangeLog = sweepstakeChangeLog;
        _this.createSweepstakeDraw = createSweepstakeDraw;
        _this.brandClientService = brandClientService;
        _this.sweepstakeTicketLines = sweepstakeTicketLines;
        _this.sweepstakeTickets = sweepstakeTickets;
        _this.sweepstakeDraw = sweepstakeDraw;
        _this.sweepstakeBrandSettings = sweepstakeBrandSettings;
        _this._isOpenedFromLotteryAdmin = 'true';
        _this._isOpenedFromBrandAdmin = 'false';
        _this.activityLogEntitiesSave = [EntityTypes.Sweepstake];
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(Sweepstake.prototype, "defaultSweepstake", {
        get: function () {
            return {
                sweepstakeId: 0,
                name: null,
                guid: Guid.generateGuid(),
                isActive: true,
                isDefault: false,
                sequenceNumber: 0,
                batchSize: 0,
                currentSweepstakeDrawId: null,
                currencyId: 0,
                createdDate: new Date(),
                notes: null,
                sweepstakePrizeTiers: [],
                entityType: EntityTypes.Sweepstake,
                identifier: Guid.generateGuid(),
                pricingModels: [],
                sweepstakeDraws: [],
                timezone: "",
                drawTimeHours: 0,
                drawTimeMinutes: 0,
                ticketSalesClosingTimeOffsetInMinutes: null,
                minimumTicketsSold: 0,
                sweepstakePickResultFromId: 0,
                setting: null,
                openDate: new Date(),
                categoryLinks: []
            };
        },
        enumerable: false,
        configurable: true
    });
    Sweepstake.prototype.activate = function (params, navigationInstruction) {
        if (params.isOpenedFromLotteryAdmin)
            this._isOpenedFromLotteryAdmin = params.isOpenedFromLotteryAdmin;
        if (params.isOpenedFromBrandAdmin)
            this._isOpenedFromBrandAdmin = params.isOpenedFromBrandAdmin;
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Sweepstake.prototype.attached = function () {
        var _this = this;
        var options = this.getOptions();
        if (options) {
            this.brandClientService
                .getBrandCurrencies({ brandId: options && options.brandId ? options.brandId : null })
                .then(function (response) { return _this._brandCurrencies = response.brandCurrencies; })
                .catch(function () { });
        }
        if (!this.item.sweepstakeId || !this.item.guid) {
            setTimeout(function () {
                _this.item.guid = Guid.generateGuid();
            }, 0);
        }
        return _super.prototype.attached.call(this);
    };
    Sweepstake.prototype.initializeItemOverride = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.brandId = options && options.brandId ? options.brandId : null;
            newItem.createdDate = new Date();
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    Sweepstake.prototype.initializeItemOverrideForUpdate = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.brandId = options && options.brandId ? options.brandId : null;
            newItem.createdDate = new Date();
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    Sweepstake.prototype.getOptions = function () {
        return this._params;
    };
    Sweepstake.prototype.setNavigationInfo = function (newItem) {
        var options = this.getOptions();
        var brandId = options && !newItem.updateBrandSweepstake && options.brandId ? options.brandId : null;
        newItem.navigationInfo = {
            isOpenedFromLotteryAdmin: options ? options.isOpenedFromLotteryAdmin : true,
            isOpenedFromBrandAdmin: options ? options.isOpenedFromBrandAdmin : null,
            brandId: newItem.updateBrandSweepstake ? newItem.updateBrandSweepstake.brandId : brandId,
            brandName: options ? options.brandName : null,
            brandLanguages: options ? options.brandLanguages : null,
            brandInstantGames: options ? options.brandInstantGames : null,
            brandSweepstakes: options ? options.brandSweepstakes : null,
            brandDefaultCurrencyId: options ? options.brandDefaultCurrencyId : null,
            brandTemplateInternalName: options && options.brandTemplateInternalName ? options.brandTemplateInternalName : "",
            brandThemeInternalName: options && options.brandThemeInternalName ? options.brandThemeInternalName : "",
            redirectUrl: options && options.redirectUrl && !newItem.updateBrandSweepstake ? options.redirectUrl : "",
            isPromotion: options && options.isPromotion && !newItem.updateBrandSweepstake ? options.isPromotion : false,
        };
        if (newItem.updateBrandSweepstake && newItem.updateBrandSweepstake.redirectUrl) {
            newItem.navigationInfo.redirectUrl = newItem.updateBrandSweepstake.redirectUrl;
        }
        if (newItem.updateBrandSweepstake && newItem.updateBrandSweepstake.isPromotion)
            newItem.navigationInfo.isPromotion = newItem.updateBrandSweepstake.isPromotion;
    };
    Sweepstake.prototype.initValidations = function (newItem) {
        var totalNumberOfWinners = 0;
        // reset invalid data before validation
        if (newItem.sweepstakePrizeTiers) {
            var prizeTiers = Enumerable.from(newItem.sweepstakePrizeTiers);
            totalNumberOfWinners = prizeTiers.sum(function (x) { return x.numberOfWinners; });
            prizeTiers.forEach(function (x) {
                if (!x.hasMonetaryValue) {
                    x.winningAmountTypeId = null;
                    x.winningAmount = null;
                    x.minimumWinningAmountThreshold = null;
                    x.percentageOfContribution = null;
                    return;
                }
                x.nonMonetaryPrizeText = null;
                if (x.winningAmountTypeId === WinningAmountTypeEnum.Static) {
                    x.minimumWinningAmountThreshold = null;
                    x.percentageOfContribution = null;
                    return;
                }
                if (x.winningAmountTypeId === WinningAmountTypeEnum.DynamicByContribution) {
                    x.winningAmount = null;
                    return;
                }
            });
        }
        if (newItem.categoryLinks == null)
            newItem.categoryLinks = [];
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required.")
            .ensure(function (x) { return x.currencyId; }).satisfies(function (x) { return x > 0; }).withMessage("Currency is required.")
            .ensure(function (x) { return x.batchSize; }).satisfies(function (x) { return x > 0 && x >= 1000; }).withMessage("Batch Size is required and cannot be zero. The minimum batch size should be at least 1000")
            .ensure(function (x) { return x.sweepstakePickResultFromId; }).satisfies(function (x) { return x > 0; }).withMessage("Pick Result From is required.")
            .ensure(function (x) { return x.minimumTicketsSold; })
            .satisfies(function (x) {
            //must be greater than zero and at least 3 times more than the number of winners
            var threeTimesNumberOfWinners = totalNumberOfWinners * 3;
            var isValid = x > 0 && x > threeTimesNumberOfWinners;
            return isValid;
        }).withMessage("Minimum Tickets Sold is required and cannot be zero or less than 3 times of the number of winners")
            .ensure(function (x) { return x.ticketSalesClosingTimeOffsetInMinutes; }).satisfies(function (x) { return x <= 0; }).withMessage("Sales Closing Time Offset is required and cannot be zero")
            .ensure(function (x) { return x.openDate; }).required().withMessage("Open date is required.")
            .ensure(function (x) { return x.sweepstakePrizeTiers; }).satisfies(function (x) { return x.length > 0; }).withMessage("At least one prize tier required.")
            .ensure(function (x) { return x.setting; })
            .satisfies(function (x) {
            var isValid = x ? (!x.hasComplementary ? true : x.hasComplementary && x.maxComplementaryNumberPerPurchase > 0) : true;
            return isValid;
        }).withMessage("The maximum Complementary Number Per Purchase cannot be zero")
            .on(newItem)
            .rules;
        this.tierRules = ValidationRules
            .ensure(function (x) { return x.name; })
            .required()
            .withMessage("Prize Tier name is required.")
            .ensure(function (x) { return x.insuranceTierName; })
            .required()
            .withMessage("Insurance Name is required.")
            .ensure(function (x) { return x.internalName; })
            .required()
            .withMessage("Internal Name is required.")
            .ensure(function (x) { return x.numberOfWinners; })
            .satisfies(function (x) { return x > 0; })
            .withMessage("Number of winners must be greater than 0.")
            .ensure(function (x) { return x.winningAmountTypeId; })
            .required()
            .when(function (x) { return x.hasMonetaryValue; })
            .withMessage("Winning Amount Type is required when Has Monetary value is checked")
            .ensure(function (x) { return x.nonMonetaryPrizeText; })
            .required()
            .when(function (x) { return !x.hasMonetaryValue; })
            .withMessage("Enter Prize text")
            .ensure(function (x) { return x.winningAmount; })
            .required()
            .when(function (x) { return x.hasMonetaryValue && x.winningAmountTypeId === WinningAmountTypeEnum.Static; })
            .withMessage("Winning Amount must be greater than 0 when Has Monetary value is checked and Winning Type is Static.")
            .ensure(function (x) { return x.minimumWinningAmountThreshold; })
            .required()
            .when(function (x) { return x.hasMonetaryValue && x.winningAmountTypeId === WinningAmountTypeEnum.DynamicByContribution; })
            .withMessage("Minimum winning amount threshold is required when Has Monetary value is checked and Winning Type is DynamicByContribution.")
            .ensure(function (x) { return x.percentageOfContribution; })
            .required()
            .when(function (x) { return x.hasMonetaryValue && x.winningAmountTypeId === WinningAmountTypeEnum.DynamicByContribution; })
            .withMessage("Winning amount contribution % is required when Has Monetary value is checked and Winning Type is DynamicByContribution")
            .ensure(function (x) { return x.percentageOfContribution; })
            .satisfies(function (x) { return !(x > 100); })
            .withMessage("Winning amount contribution percentage should be less than or equal to 100%")
            .rules;
    };
    Sweepstake.prototype.getPropertiesToSkip = function () {
        return ["navigationInfo"];
    };
    Sweepstake.prototype.getSteps = function () {
        var showBrandTabs = this.tokenClient.isBrandAdmin();
        var stepList = [];
        stepList.push({
            title: this.i18N.tr('sweepstake-basic-meta'),
            step: StepEnum.SweepstakeBasicMeta,
            show: true,
            vm: this.sweepstakeBasicMeta,
            view: '../../app/admin/sweepstake/steps/sweepstake-basic-meta.html'
        });
        if (this._isOpenedFromLotteryAdmin == 'true' || this._isOpenedFromBrandAdmin == "true") {
            stepList.push({
                title: this.i18N.tr('ticket-lines'),
                step: StepEnum.SweepstakeTickets,
                show: true,
                vm: this.sweepstakeTickets,
                view: '../../app/admin/sweepstake/steps/sweepstake-tickets.html'
            });
            stepList.push({
                title: this.i18N.tr('draws'),
                step: StepEnum.SweepstakeDraws,
                vm: this.sweepstakeDraw,
                show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
                view: '../../app/admin/sweepstake/steps/sweepstake-draws.html'
            });
            stepList.push({
                title: this.i18N.tr('change-log'),
                step: StepEnum.SweepstakeChangeLog,
                vm: this.sweepstakeChangeLog,
                show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
                view: '../../app/admin/sweepstake/steps/sweepstake-changelog.html'
            });
        }
        if (this._isOpenedFromLotteryAdmin == 'true') {
            stepList.push({
                title: this.i18N.tr('sweepstake-prize-tiers'),
                step: StepEnum.SweepstakePrizeTiers,
                vm: this.sweepstakePrizeTiers,
                show: !showBrandTabs,
                view: '../../app/admin/sweepstake/steps/sweepstake-prize-tiers.html'
            });
        }
        else {
            stepList.push({
                title: this.i18N.tr('sweepstake-tickets-prices'),
                step: StepEnum.SweepstakeTicketPrices,
                vm: this.sweepstakeTicketPrices,
                show: true,
                view: '../../app/admin/sweepstake/steps/sweepstake-ticket-prices.html'
            });
            stepList.push({
                title: this.i18N.tr('sweepstake-tickets-discounts'),
                step: StepEnum.SweepstakeTicketDiscounts,
                vm: this.sweepstakeTicketDiscounts,
                show: true,
                view: '../../app/admin/sweepstake/steps/sweepstake-ticket-discounts.html'
            });
            stepList.push({
                title: this.i18N.tr('sweepstake-brand-settings'),
                step: StepEnum.SweepstakeBrandSettings,
                vm: this.sweepstakeBrandSettings,
                show: true,
                view: '../../app/admin/sweepstake/steps/sweepstake-brand-settings.html'
            });
        }
        return stepList;
    };
    // Inherited
    Sweepstake.prototype.getItem = function (id) {
        var options = this.getOptions();
        var request = {
            id: id,
            brandId: options ? options.brandId : null,
            operatorId: options ? options.operatorId : null,
        };
        return this.sweepstakeClientService.getSweepstakeForAdmin(request);
    };
    Sweepstake.prototype.getItemId = function () {
        return this.item.sweepstakeId;
    };
    Sweepstake.prototype.getEntityType = function () {
        return EntityTypes.Sweepstake;
    };
    Sweepstake.prototype.saveItem = function (id, changes) {
        var options = this.getOptions();
        var request = {
            id: id, changes: changes,
            // only pass the brandId | operatorId if the navigation info is not null i.e. if we ar ein a Manage Brand  | Manage Operator
            brandId: options ? options.brandId : this.item.navigationInfo ? this.item.navigationInfo.brandId : null,
            operatorId: options ? options.operatorId : this.item.navigationInfo ? this.item.navigationInfo.operatorId : null,
        };
        return this.sweepstakeClientService.save(request);
    };
    Sweepstake.prototype.handleUpdateCompleted = function (response, isNew) {
        if (response && response.sweepstakeNameAlreadyExists) {
            this.notificationService.show("Validation Error!", "Sweepstakes name must be unique.", NotificationType.Error);
        }
        else {
            _super.prototype.handleUpdateCompleted.call(this, response, isNew);
        }
    };
    Sweepstake.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageSweepstakes;
    };
    Sweepstake.prototype.initializeItemForCreate = function () {
        return this.defaultSweepstake;
    };
    Sweepstake.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListSweepstakes;
    };
    Sweepstake.prototype.deleteSweepstakes = function () {
        var _this = this;
        if (!this.item.sweepstakeId) {
            return;
        }
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
            delete: function () { return new Promise(function (resolve, reject) {
                _this.sweepstakeClientService.delete({ sweepstakeId: _this.item.sweepstakeId })
                    .then(function (response) {
                    if (response.deleteSuccessfully) {
                        _this.notificationService.show(_this.i18N.tr("sweepstake-delete-notification-title"), _this.i18N.tr("sweepstake-delete-notification-message-success"), NotificationType.Success);
                        _this.router.navigateToRoute(_this.getListRoute());
                        resolve();
                    }
                    else {
                        _this.notificationService.show(_this.i18N.tr("sweepstake-delete-notification-title"), _this.i18N.tr("sweepstake-delete-notification-message-error"), NotificationType.Error);
                        reject();
                    }
                })
                    .catch(function () {
                    _this.notificationService.show(_this.i18N.tr("sweepstake-delete-notification-title"), _this.i18N.tr("sweepstake-delete-notification-message-error"), NotificationType.Error);
                    reject();
                });
            }); }
        });
    };
    Sweepstake.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ].concat(Enumerable.from(this.item.sweepstakePrizeTiers)
            .select(function (a) { return _this.controller.validate({ object: a, rules: _this.tierRules }); })
            .toArray()))
            .then(function (result) {
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Sweepstake = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ValidationControllerFactory,
            DialogClientService,
            TokenClient,
            Router,
            I18N,
            BindingEngine,
            NotificationClientService,
            EventAggregator,
            SweepstakeClientService,
            SweepstakeBasicMeta,
            SweepstakePrizeTiers,
            UserClaimsService,
            SweepstakeTicketPrices,
            SweepstakeTicketDiscounts,
            SweepstakeChangeLog,
            CreateSweepstakeDraw,
            BrandClientService,
            SweepstakeTicketLines,
            SweepstakeTickets,
            SweepstakeDraw,
            SweepstakeBrandSettings])
    ], Sweepstake);
    return Sweepstake;
}(BaseEntity));
export { Sweepstake };
